import DeviceDetector from "device-detector-js";
import { env } from "../env/env";
const { detect } = require('detect-browser');
const browser = detect();
export const iosUrl = "https://apps.apple.com/in/app/google-chrome/id535886823";
export const androidUrl = "https://play.google.com/store/apps/details?id=com.android.chrome&hl=en_IN&gl=US";
export const desktopUrl = "https://www.google.com/intl/en_in/chrome/";



export const getDevice = () => {
  let device;
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    device = "mobile";
  } else {
    device = "desktop";
  }
  return device;
};

export const isIOSDevice = () => {
  const iOS = /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  return iOS;
};

export const isAndroidDevice = () => {
  const android = /(android)/i.test(navigator.userAgent);
  return android;
};

export const validBrowser = () => {
  console.log("userAgent data", browser);
  if (navigator.userAgent.indexOf("XiaoMi") != -1) {
    console.log('not supported');
    console.log("navigator", window.navigator);
    return false;
  }
  else {
    switch (browser && browser.name) {
      case 'chrome':
      case 'android webview':
      case 'samsung':
      case 'firefox':
      case 'safari':
      case 'ios':
      case 'crios':
      case 'edge-chromium':
        console.log("supported");
        return true;

      default:
        console.log('not supported');
        console.log("navigator", window.navigator);
        return false;
    }
  }
}

export const validBrowserForNewUi = () => {
  console.log("userAgent data", browser);
  if (navigator.userAgent.indexOf("XiaoMi") != -1) {
    console.log('not supported');
    console.log("navigator", window.navigator);
    return false;
  }
  if (navigator.userAgent.indexOf("Opera") != -1 || navigator.userAgent.indexOf('OPiOS') != -1 || navigator.userAgent.indexOf('OPT') != -1 || typeof window.opr !='undefined') {
    return false
  }
  else {
    switch (browser && browser.name) {
      case 'chrome':
      case 'safari':
      case 'ios':
      case 'crios':
        console.log("supported");
        return true;

      default:
        console.log('not supported');
        console.log("navigator", window.navigator);
        return false;
    }
  }
}

export const isFirefox = () => {
  if (browser && (browser.name == "firefox")) {
    return true;
  } else {
    return false
  }
}


export const getDeviceBrowserInfo = () => {
  const deviceDetector = new DeviceDetector();
  const userAgent = navigator.userAgent;
  const deviceInfo = deviceDetector.parse(userAgent);
  console.log('deviceInfo', deviceInfo)
  return deviceInfo

}

export const getPosvUrl = (txnId) => {
  if (env == 'mliProd') {
    return `https://posv.maxlifeinsurance.com/vu?id=${txnId} `
  }
  else if (env == 'mliUat') {
    return `https://posvuat.maxlifeinsurance.com/vu?id=${txnId} `
  }
  else {
    return `https://posvdev.maxlifeinsurance.com/vu?id=${txnId} `
  }
}